import { render, staticRenderFns } from "./LinkWithHover.vue?vue&type=template&id=68720b42"
import script from "./LinkWithHover.vue?vue&type=script&lang=js"
export * from "./LinkWithHover.vue?vue&type=script&lang=js"
import style0 from "./LinkWithHover.vue?vue&type=style&index=0&id=68720b42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports